function loadItems(_this = null) {
    const section = document.querySelector(".landing-grid");
    if (section) {
        const id = section.dataset.id;
        const type = section.dataset.type;
        const ids = section.dataset.ids;
        const url = section.dataset.url;
        const data = new FormData();
        data.append("action", "get_landing_grid");
        data.append("type", type);
        data.append("ids", ids);
        data.append("id", id);
        const loadMoreBtn = document.getElementById("landing-grid__load-more");
        if (loadMoreBtn) {
            loadMoreBtn.remove();
        }
        fetch(url, {
            method: "POST",
            credentials: "same-origin",
            body: data,
        })
            .then((response, group) => {
                if (response.ok) {
                    return response.text();
                }
                throw new Error("Something went wrong");
            })
            .then(function (data) {
                const container = document.getElementById("landing-grid__container");
                const content = document.getElementById("landing-grid__content");
                if (container && data) {
                    const parser = new DOMParser();
                    const htmlResponse = parser.parseFromString(data, "text/html");
                    const html = htmlResponse.body.innerHTML;
                    if (html) {
                        content.innerHTML += html;
                    }
                    const loadMore = htmlResponse.getElementById("landing-grid__load-more");
                    if (loadMore) {
                        loadMore.remove();
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
}

document.body.addEventListener("click", function (e) {
    if (e.target && e.target.matches(".landing-load-more")) {
        e.preventDefault();
        loadItems(this);
    }
});
